import React from "react";
import { Link } from "gatsby";

import { useLanguageContext } from "../../contexts/language-context";

// Font Awesome icons
import Icon from "../../components/custom-widgets/icon";

const bellyBandData = [
  {
    id: "belly-band-card-checking-account",
    icon: "money-check",
    textLg: "Open a Checking Account",
    textMd: "Checking Accounts",
    textSm: "Checking",
    url: "/personal-banking/checking-account"
  },
  {
    id: "belly-band-card-savings-account",
    icon: "piggy-bank",
    textLg: "Open a Savings Account",
    textMd: "Savings Accounts",
    textSm: "Savings",
    url: "/personal-banking/savings-account"
  },
  {
    id: "belly-band-card-home-loans",
    icon: "home",
    textLg: "Apply for a Mortgage or Refinance",
    textMd: "Home Loans",
    textSm: "Home Loans",
    url: "/personal-banking/home-loans/home-mortgage"
  },
  {
    id: "belly-band-card-credit-cards",
    icon: "credit-card",
    textLg: "Browse our Credit Cards",
    textMd: "Credit Cards",
    textSm: "Credit Cards",
    url: "/personal-banking/credit-cards"
  },
  {
    id: "belly-band-card-branch-locations",
    icon: "map-marker-alt",
    textLg: "Find a Branch Location",
    textMd: "Branch Locations",
    textSm: "Branches",
    url: "/locations"
  },
  {
    id: "belly-band-card-small-business",
    icon: "building",
    textLg: "Explore Small Business Banking",
    textMd: "Small Business",
    textSm: "Small Business",
    url: "/business-banking/small-business"
  }
];

const spanishBellyBandData = [
  {
    id: "es-belly-band-checking",
    icon: "money-check",
    text: "Cuenta de Cheques",
    url: "/es/banca-personal/cuenta-de-cheques"
  },
  {
    id: "es-belly-band-savings",
    icon: "piggy-bank",
    text: "Cuenta de Ahorro",
    url: "/es/banca-personal/cuentas-de-ahorro"
  },
  {
    id: "es-belly-band-home-loans",
    icon: "home",
    text: "Prestamos Hipotecarios",
    url: "/es/banca-personal/prestamos-hipotecarios"
  },
  {
    id: "es-belly-band-credit-cards",
    icon: "credit-card",
    text: "Tarjetas de Credito",
    url: "/es/banca-personal/tarjetas-de-credito"
  },
  {
    id: "es-belly-band-locations",
    icon: "map-marker-alt",
    text: "Ubicacion de Sucursales",
    url: "/es/sucursales"
  },
  {
    id: "es-belly-band-faqs",
    icon: "question-circle",
    text: "Pregunatas Frecuentes",
    url: "/es/preguntas-frecuentes"
  }
];

const BellyBand = () => {
  const isSpanish = useLanguageContext();
  return (
    <div id="home-head-band" className="border-bottom">
      <div className="container">
        <div className="row">
          {isSpanish
            ? spanishBellyBandData.map((bbCard) => (
                <div key={bbCard.id} className="text-center col-sm-4 col-md-4 col-lg-2">
                  <Link to={bbCard.url} className="d-block text-black h-100">
                    <div className="d-none d-md-block">
                      <div className="pt-3">
                        <Icon class="fa-lg" name={bbCard.icon} />
                      </div>
                      <div className="p-2 text-smaller">
                        <span>{bbCard.text}</span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center d-md-none">
                      <div className="py-2 mx-3">
                        <Icon class="fa-1x" name={bbCard.icon} />
                      </div>
                      <div className="py-2" style={{ width: "10rem" }}>
                        <div className="float-left">{bbCard.text}</div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            : bellyBandData.map((bbCard) => (
                <div key={bbCard.id} className="text-center col-sm-4 col-md-4 col-lg-2">
                  <Link to={bbCard.url} className="d-block text-black h-100">
                    <div className="d-none d-md-block">
                      <div className="pt-3">
                        <Icon class="fa-lg" name={bbCard.icon} />
                      </div>
                      <div className="p-2 text-smaller">
                        <span className="d-none d-lg-inline">{bbCard.textMd}</span>
                        <span className="d-none d-md-inline d-lg-none">{bbCard.textMd}</span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center d-md-none">
                      <div className="py-2 mx-3">
                        <Icon class="fa-1x" name={bbCard.icon} />
                      </div>
                      <div className="py-2" style={{ width: "10rem" }}>
                        <div className="d-none d-sm-block d-md-none float-left">{bbCard.textSm}</div>
                        <div className="d-xs-block d-sm-none float-left">{bbCard.textMd}</div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default BellyBand;
